// Tüm sunucu adresleri burada. Ortam değişkeni verilmezse canlı adresler kullanılır;
// `npm run build` (canlı) bu varsayılanlarla çalışır. Lokal geliştirme için .env.development'a bakın.

// .NET API (örn. lokal: http://localhost:5187)
export const API_ROOT = process.env.REACT_APP_API_ROOT || "https://api.heryerdeingilizce.com";
export const API_BASE_URL = API_ROOT + "/api";

// Sabit ses/resim dosyaları ve veritabanında göreli yol olarak duran medya canlı dosya sunucusunda
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_URL || "https://api.heryerdeingilizce.com";

export const EXPRESS_BASE_URL = process.env.REACT_APP_EXPRESS_URL || "https://express.heryerdeingilizce.com";
